import { ObjectHelper, Store } from "@bryntum/schedulerpro";
import { Board } from "../../models/Board.jsx";
import { addBoard, updateBoard } from "../../../network/network.jsx";
import { getFormattedBoardData, serverErrorMsg, showToast } from "../../../other/utils/utils.jsx";

/**
 * @description - swivuBoardStore is responsible for managing board ajax requests for CUD operations
 */
export const swivuBoardStore = () => new Store({
  modelClass: Board,
  listeners: {
    add({ records }) {
      if (records.length) {
        const record = records[0];
        if (record.isPhantom) { // import board thing also handled here
          addBoard({ display_name: record.name, source_board_id: record.boardIdToCopy, selected_options: record.boardDataCopyOptions })
          .then(({ data }) => {
            // record.set(data, true) does the job of setting record but if you try to check whether store has to be updated changes using this.changes then you'll see the record just added will appear there
            // and that may cause an issue whether bryntum automatically tries to those changes implicitly
            const serverResponse = { updated: [{ ...getFormattedBoardData(data), $PhantomId: record.id }], };
            this.applyChangeset(serverResponse);
          })
          .catch((e) => {
            console.log(e);
            showToast({ msg: serverErrorMsg() });
            this.trigger("swivuAddBoardFailed", { error: e });
          });
        }
      }
    },
    update(event) {
      const { changes, record } = event;
      // checking id here, since calling set on model after adding record triggering this update event as well
      // (despite called "set" with silent to true). so usually record don't update id so checking id here to make sure it's not a new record
      // Need a better fix
      //Fix: Applied this check to ensure no api call should be made without board name
      if (changes && !("id" in changes) && !ObjectHelper.isEmpty(changes) && (changes.name || changes.owner)) {
        updateBoard(record.slug, { display_name: changes.name?.value, owner: changes.owner?.value }).then(({ data }) => {
          this.applyChangeset({ updated: [getFormattedBoardData(data)] })
        }).catch(() => showToast({ msg: serverErrorMsg() }));
      }
    },
  }
});
